import React from "react";
import { motion } from "framer-motion";
import { FaShareAlt, FaCheckCircle, FaArrowRight } from "react-icons/fa";

const T = {
  accent: "#eab308",
  accentDim: "rgba(234,179,8,0.1)",
  textPrimary: "#f0f6ff",
  textSecondary: "#94a3b8",
  textMuted: "#4b6280",
  border: "#1a2d4a",
  success: "#22c55e",
};

export default function TaskCard({ task, onStart }) {
  const isCompleted = task.status === "completed";
  const Icon = task.icon || FaShareAlt;

  return (
    <div style={{ padding: "24px 22px" }}>
      {/* ── header row ── */}
      <div style={{
        display: "flex", alignItems: "flex-start", justifyContent: "space-between",
        gap: 16, marginBottom: 22,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, minWidth: 0 }}>
          <motion.div
            whileHover={{ scale: 1.08 }}
            style={{
              width: 46, height: 46, borderRadius: 15,
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0,
              background: isCompleted ? T.accent : "rgba(255,255,255,0.04)",
              border: isCompleted ? "none" : `1px solid rgba(234,179,8,0.25)`,
              color: isCompleted ? "#0a0d14" : T.accent,
              transition: "all 0.25s",
              boxShadow: isCompleted ? `0 6px 18px rgba(234,179,8,0.35)` : "none",
            }}
          >
            <Icon size={18} />
          </motion.div>
          <div style={{ minWidth: 0 }}>
            <h3 style={{
              fontSize: 13, fontWeight: 900, color: T.textPrimary,
              textTransform: "uppercase", letterSpacing: "-0.01em",
              margin: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
            }}>
              {task.title}
            </h3>
            <p style={{
              fontSize: 10, fontWeight: 700, color: T.textMuted,
              textTransform: "uppercase", letterSpacing: "0.12em", margin: "2px 0 0",
            }}>
              {task.type} Operation
            </p>
          </div>
        </div>

    
      </div>

      {/* ── description ── */}
      <p style={{
        fontSize: 12, color: T.textSecondary, fontWeight: 500,
        lineHeight: 1.6, marginBottom: 16,
      }}>
        {task.description || "Execute this operation to accrue daily yield points and maintain plan eligibility."}
      </p>

      {/* ── status progress ── */}
      <div style={{ marginBottom: 18 }}>
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          fontSize: 9, fontWeight: 900, textTransform: "uppercase", letterSpacing: "0.18em",
          marginBottom: 8,
        }}>
          <span style={{ color: isCompleted ? T.accent : T.textMuted }}>
            Status: {isCompleted ? "Verified" : "Pending"}
          </span>
          <span style={{ color: T.textPrimary }}>{isCompleted ? "100%" : "0%"}</span>
        </div>
        <div style={{
          width: "100%", height: 6,
          background: "rgba(255,255,255,0.05)",
          borderRadius: 999, overflow: "hidden",
        }}>
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: isCompleted ? "100%" : "0%" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              height: "100%", borderRadius: 999,
              background: isCompleted
                ? `linear-gradient(90deg,${T.accent},#f59e0b)`
                : "linear-gradient(90deg,#fde68a,#eab308,#f59e0b)",
              boxShadow: isCompleted ? `0 0 10px rgba(234,179,8,0.5)` : "none",
            }}
          />
        </div>
      </div>

      {/* ── footer row ── */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
        {isCompleted ? (
          <div style={{
            display: "flex", alignItems: "center", gap: 6,
            padding: "5px 12px",
            background: T.accentDim,
            border: `1px solid rgba(234,179,8,0.25)`,
            borderRadius: 999,
          }}>
            <FaCheckCircle size={9} color={T.accent} />
            <span style={{ fontSize: 9, fontWeight: 900, color: "#fde68a", textTransform: "uppercase", letterSpacing: "0.1em" }}>
              Confirmed
            </span>
          </div>
        ) : (
          <span style={{ fontSize: 9, fontWeight: 900, color: T.textMuted, textTransform: "uppercase", letterSpacing: "0.15em" }}>
            Ready for execution
          </span>
        )}

        <motion.button
          disabled={isCompleted}
          onClick={() => !isCompleted && onStart(task)}
          whileHover={!isCompleted ? { scale: 1.05 } : {}}
          whileTap={!isCompleted ? { scale: 0.95 } : {}}
          style={{
            display: "flex", alignItems: "center", gap: 7,
            padding: "10px 18px", borderRadius: 12,
            fontSize: 9, fontWeight: 900, textTransform: "uppercase", letterSpacing: "0.15em",
            border: "none", cursor: isCompleted ? "default" : "pointer",
            background: isCompleted
              ? "rgba(255,255,255,0.04)"
              : `linear-gradient(135deg,${T.accent},#f59e0b)`,
            color: isCompleted ? T.textMuted : "#0a0d14",
            boxShadow: isCompleted ? "none" : `0 8px 22px rgba(234,179,8,0.3)`,
            transition: "box-shadow 0.2s",
          }}
        >
          {isCompleted ? "Completed" : (
            <>
              Start Task <FaArrowRight size={8} />
            </>
          )}
        </motion.button>
      </div>
    </div>
  );
}